document.addEventListener('DOMContentLoaded', () => {
  const liElements = document.querySelectorAll(
    'li.posts-post.d-flex.align-items-stretch.justify-content-center'
  )

  liElements.forEach((liElement) => {
    const articleElement = liElement.querySelector('article')

    if (articleElement) {
      const articleLiElements = articleElement.querySelectorAll('ul li')
      const lastLiElement = articleLiElements[articleLiElements.length - 1]

      if (lastLiElement) {
        liElement.innerHTML = lastLiElement.innerHTML
        liElement.className = lastLiElement.className
      }
    }
  })
})
